import { createAsyncThunk } from '@reduxjs/toolkit';
import { Budget } from './budgetsTypes';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create
export const createBudget = createAsyncThunk(
  'budgets/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.post('/budgets', data);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create budget');
    }
  }
);

// Get All
export const fetchAllBudgets = createAsyncThunk(
  'budgets/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get('/budgets');
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch budgets');
    }
  }
);

// Get By ID
export const fetchBudgetById = createAsyncThunk(
  'budgets/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get(`/budgets/${id}`);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch budget');
    }
  }
);

// Update
export const updateBudget = createAsyncThunk(
  'budgets/update',
  async ({ id, data }: { id: number; data: any }, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.put(`/budgets/${id}`, data);
      return { id, data };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update budget');
    }
  }
);

// Delete
export const deleteBudget = createAsyncThunk(
  'budgets/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/budgets/${id}`);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete budget');
    }
  }
);
